import React from 'react'
import { CheckboxSelector, Avatar, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const EducatorFilter = (props) => {
  const { translate } = useTranslation()
  const { students, studentFilters, setStudentFilters, loading, useInner = false } = props
  // const handledInput = (value) => {
  //   onChangeInput(value)
  // }

  const educatorOptions = students.map(user => ({
    name: `${user.firstName} ${user.lastName}`,
    id: user.id,
    Component: (
      <Avatar
        name={`${user.firstName} ${user.lastName}`}
        named={false}
        uri={null}
        size='avatar-small'
      />
    )
  })).sort((a, b) => a.name.localeCompare(b.name))

  const checkboxSelectorProps = {
    setDataFilters: setStudentFilters,
    direction: 'bottomLeft',
    dataFilters: studentFilters,
    loading: loading,
    data: educatorOptions,
    typeFilter: 'users',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
    // onChangeInput={handledInput}
  }

  return (
    useInner ?
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/> :
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title={translate('filters.plans.educatorsTitle')}
        options={educatorOptions}
        selectedIds={studentFilters}
        onClearFilters={() => setStudentFilters([])}
      />
    </CheckboxSelector>
  )
}
export default EducatorFilter
